import { AsyncPageRender } from '@components/AsyncComponent';
import { RenderComponent } from '@components/Layout/ProtectedRoute';
import { pageModule } from '@components/pageModule';
import { Route } from '@packages/router';
import React from 'react';

export const routes$ = {
    List: AsyncPageRender(() => pageModule(import('./List'))),
    Request: AsyncPageRender(() => pageModule(import('./Request'))),
};

function Router() {
    return (
        <>
            <Route
                name={'Designs.Request.Create'}
                exact
                path={'/designs/request/:id/:step'}
                component={RenderComponent(routes$.Request, true)}
            />
        </>
    );
}

export default Router;
